import { collectionEngineV1 } from '../apis.js';
const documentsV1API = collectionEngineV1('/documents');
export const add = (refId, type, refIdType, fileId, isSigned, signedAt, date, minAccessRole, meta) => documentsV1API('POST', `/`, {
    body: {
        refId,
        type,
        fileId,
        isSigned,
        signedAt,
        date,
        minAccessRole,
        meta,
        refIdType,
    },
});
export const get = (refId, casualConsistency) => documentsV1API('GET', `/${refId}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const update = (documentId, document) => documentsV1API('PATCH', '/' + documentId, {
    body: document,
});
export const del = (documentId) => documentsV1API('DELETE', '/' + documentId);
export const getLinkToSignDocument = async (documentId, role, name, successURL) => documentsV1API('GET', `/get-signing-link/${encode(documentId)}/${encode(role)}/${encode(name)}?successURL=${successURL ? encode(successURL) : ''}`);
const encode = (s) => encodeURIComponent(encodeURIComponent(s));
//# sourceMappingURL=documents.js.map